<template>
  <v-menu
    offset-x
    right
    :close-on-content-click="false"
    :max-width="250"
    :nudge-width="100"
    transition="slide-x-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-if="isMobile" icon v-on="on">
        <v-avatar size="40" :color="$vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'">
          <v-img v-if="ProfileInfo.url_image" :src="ProfileInfo.url_image" alt="Avatar del usuario"></v-img>
          <v-icon color="blue-grey" v-else>mdi-account</v-icon>
        </v-avatar>
      </v-btn>
      <v-btn
        v-else
        large
        :outlined="isDark"
        depressed
        :color="isDark ? 'blue-grey darken-3' : 'deep-purple lighten-5 primary--text'"
        v-on="on"
        class="pr-2 rounded-small"
      >
        <!-- <v-icon left>mdi-account-circle-outline</v-icon> -->
        <span class="mr-2">{{ ProfileInfo.name }}</span>
        <v-avatar size="34" :color="$vuetify.theme.dark ? 'deep-purple darken-4' : 'deep-purple lighten-4'">
          <v-img v-if="ProfileInfo.url_image" :src="ProfileInfo.url_image" alt="Avatar del usuario"></v-img>
          <v-icon color="primary" v-else>mdi-account</v-icon>
        </v-avatar>
      </v-btn>
    </template>

    <v-card>
      <v-list dense>
        <v-list-item>
          <v-list-item-avatar size="40" tile>
            <v-avatar size="40" :color="$vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'">
              <v-img v-if="ProfileInfo.url_image" :src="ProfileInfo.url_image" alt="Avatar del usuario"></v-img>
              <v-icon color="blue-grey" v-else>mdi-account</v-icon>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="mb-2 text-uppercase primary--text">
              {{ ProfileInfo.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ UserRol }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item dense v-if="ProfileInfo.extension">
          <v-list-item-icon>
            <v-icon small class="pl-1">
              mdi-phone
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-subtitle>{{ ProfileInfo.extension }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item dense :class="ProfileInfo.extension ? 'mt-n3' : ''" v-if="ProfileInfo.email">
          <v-list-item-icon>
            <v-icon small class="pl-1">
              mdi-email
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-subtitle> {{ ProfileInfo.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="my-0 py-0"></v-divider>

      <v-list dense>
        <v-list-item>
          <v-list-item-icon class="mr-6">
            <v-icon>mdi-theme-light-dark</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Tema oscuro</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch
              small
              inset
              v-model="$vuetify.theme.dark"
              @change="saveTheme"
              color="success"
              class="ml-auto"
            ></v-switch>
          </v-list-item-action>
        </v-list-item>

        <template v-if="isAgent && !AutoAnswerCalls">
          <v-list-item v-if="hasRTC">
            <v-list-item-icon class="mr-6">
              <v-icon>mdi-phone-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <!-- {{ isConnectedToSIP ? "Conectado" : "Desconectado" }} -->
                Teléfono
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-switch
                small
                inset
                :input-value="isConnectedToSIP"
                @change="toggleIsConnectedToSip"
                color="success"
                class="ml-auto"
              ></v-switch>
            </v-list-item-action>
          </v-list-item>
        </template>

        <v-list-item v-if="ProfileInfo.enable_queues_chat">
          <v-list-item-icon class="mr-6">
            <v-icon>mdi-human-queue</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> Cola </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-switch
              small
              inset
              v-model="plantConnect"
              @change="verifyExtension"
              color="success"
              class="ml-auto"
            ></v-switch>
          </v-list-item-action>
        </v-list-item>

        <v-list-item v-for="item in menuItems" :key="item.title" link :to="{ name: item.path }">
          <v-list-item-icon class="mr-6">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout()">
          <v-list-item-icon class="mr-6">
            <v-icon>mdi-location-exit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <set-extension
      v-if="showExtensionDialog"
      :active="showExtensionDialog"
      @dialog:change="handleExtensionFromDialog"
    ></set-extension>
  </v-menu>
</template>

<script>
import SetExtension from "@/components/Utils/setExtension.vue";

export default {
  components: { SetExtension },
  data: () => ({
    isLoading: false,
    plantConnect: false,
    showExtensionDialog: false,
    menuItems: [
      // { title: "Pausas", icon: "mdi-coffee", action: "Perfil" },
      { title: "Perfil", icon: "mdi-account-circle", path: "Perfil" },
    ],
  }),

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    isDark() {
      return this.$vuetify.theme.dark;
    },

    isAgent() {
      return this.ProfileInfo?.role_id == 3;
    },

    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },

    isConnectedToSIP() {
      return this.$store.getters["dialer/GET_IS_CONNECTED"];
    },

    hasRTC() {
      return !!this.ProfileInfo.web_rtc;
    },

    AutoAnswerCalls() {
      return !!this.ProfileInfo.web_rtc?.auto_answer;
    },

    ConnectValue() {
      return this.ProfileInfo?.connect;
    },

    UserRol() {
      switch (this.ProfileInfo.role_id) {
        case 1:
          return "Superusuario";

        case 2:
          return "Supervisor";

        case 3:
          return "Agente";

        default:
          return "";
      }
    },
  },

  created() {
    let theme = localStorage.getItem("theme");
    let isTrueSet = theme == "true";
    this.$vuetify.theme.dark = isTrueSet;
  },

  watch: {
    ConnectValue(val) {
      this.plantConnect = val == 1;
    },
  },

  methods: {
    saveTheme() {
      localStorage.setItem("theme", this.$vuetify.theme.dark);
    },

    toggleIsConnectedToSip() {
      this.$store.dispatch("dialer/TOGGLE_IS_CONNECTED");
    },

    async GetProfileInfo() {
      try {
        await this.$store.dispatch("passport/ACTIVE_USER");
      } catch (error) {
        console.error("error al obtener perfil", error);
      }
    },

    verifyExtension() {
      if (this.ProfileInfo.connect === 0 && this.ProfileInfo.extension === null) {
        this.showExtensionDialog = true;
      }
      // auxiliar, luego borrar al corregir datos en backend
      else if (this.ProfileInfo.connect === 0 && this.ProfileInfo.extension == 0) {
        this.showExtensionDialog = true;

        return;
      } else {
        this.connect(this.ProfileInfo.extension);
      }
    },

    handleExtensionFromDialog(data, parameters) {
      this.getExtensionDialog = false;
      if (data !== "cerrar") {
        // console.log("event", data);
        // console.log("event 2", parameters);
        this.connect(parameters);
      }
    },

    async connect(extension) {
      this.isLoadingConnect = true;

      try {
        const res = await this.$store.dispatch("passport/UPDATE_CONNECTION_AGENT", extension);

        if (res.status === 200) {
          for (const client of res.data) {
            switch (client.codigo) {
              case "Added":
                this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                break;

              case "Command":
                this.$snotify.error(`Cola ${client.queue}: ${client.message}`, "¡Error!");

                break;

              case "Removed":
                this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                break;
            }
          }
          this.GetProfileInfo();
        }
      } catch (error) {
        console.error(error);
        this.$snotify.error("Error al conectar a planta.", "Error 500");
      } finally {
        this.isLoadingConnect = false;
      }
    },

    async logout() {
      try {
        this.$store.commit("layout/SET_OVERLAY", { value: true, title: "Cerrando sesion" });
        await this.$store.dispatch("passport/LOGOUT");
        this.$router.push({ name: "login" });
      } catch (e) {
        // statements
        // console.error(e);
        this.$snotify.error(e.response.data.error, "Error");
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },
  },
};
</script>

<style></style>
